import styled from "styled-components/macro";

export const DropdownMenu = styled.div<{
  $isOpen: boolean;
  $top: number;
  $left: number;
}>`
  position: fixed;
  top: ${({ $top }) => $top}px;
  left: ${({ $left }) => $left}px;
  z-index: 15;
  min-width: max-content;
  padding: 10px;
  background-color: ${({ theme }) => theme.white};
  border: 1px solid ${({ theme }) => theme.neutral200};
  border-radius: 10px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  visibility: ${({ $isOpen }) => ($isOpen ? "visible" : "hidden")};
  pointer-events: ${({ $isOpen }) => ($isOpen ? "auto" : "none")};
  transition:
    opacity 0.15s ease,
    visibility 0.15s ease;
`;

export const DropdownContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 20px;
  z-index: 5;
`;

export const DropdownTrigger = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  border-radius: 4px;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.greenDark};
    outline-offset: 2px;
  }

  svg {
    cursor: pointer;
  }
`;

export const DropdownItem = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 20px;
  background: none;
  border: none;
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.greyDark};
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${({ theme }) => theme.greenPastel};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.greenDark};
    outline-offset: -2px;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
